<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_purchase_product_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="采购单号">
							<c-input name="purchase_code"></c-input>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="purchase_states" :options="purchaseStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="供应商">
							<c-select name="supplier_ids" async multiple @search="searchSupplier"></c-select>
						</m-search-item>
						<m-search-item label="采购员">
							<c-select name="purchase_user_ids" async multiple @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="支持产品编号/名称/规格"></c-input>
						</m-search-item>
						<m-search-item label="计划交期" colspan="2">
							<c-datetime range start-name="plan_delivery_start_date" end-name="plan_delivery_end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_purchase_product_export')" v-lock="lock('b_purchase_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_purchase_product_export')" v-lock="lock('b_purchase_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_purchase_product_export')" v-lock="lock('b_purchase_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_purchase_product_export')" v-lock="lock('b_purchase_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_purchase_product_print')" v-lock="lock('b_purchase_product_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #purchase_code="{data}">
					<c-link @click="globalDialog('purchaseOrderDetail', {props: {id: data.purchase_order_id}})">{{data.purchase_code}}</c-link>
				</template>

				<!--状态-->
				<template #purchase_state="{data}">
					<c-state dict="purchaseStateDic" tag :value="data.purchase_state"></c-state>
				</template>

				<!--关联订单号-->
				<template #order_code="{data}">
					<span v-if="data.order_code">{{data.order_code}}</span>
					<span v-else>-</span>
				</template>

				<!--采购参考价-->
				<template #purchase_price="{data}">
					<span v-if="data.purchase_price">￥{{data.purchase_price}}</span>
					<span v-else>-</span>
				</template>

				<!--采购金额-->
				<template #purchase_money="{data}">
					<span v-if="data.purchase_money">￥{{data.purchase_money}}</span>
					<span v-else>-</span>
				</template>
				<!--采购金额 -合计行-->
				<template #purchase_money_summed="{total}">
					￥{{total}}
				</template>

				<!--产品来源-->
				<template #product_source="{data}">
					<c-state dict="productSourceName" :value="data.product_source"></c-state>
				</template>

				<!--产品类型-->
				<template #product_type="{data}">
					<c-state dict="productTypeName" :value="data.product_type"></c-state>
				</template>

				<!--采购进度%-->
				<template #purchase_progress="{data}">
					<c-progress :rate="[data.purchase_progress, 100]" :color="(data.purchase_progress/100>=1||data.purchase_progress==0)?'green':'blue'"></c-progress>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="60"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_purchase_product_print')" v-lock="lock('b_purchase_product_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		components: {

		},

		data() {
			return {
				workType: 40            //采购单明细业务
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['purchaseStateDic'])
		},

		methods: {
			/*******搜索【供应商】下拉框信息*****************/
			searchSupplier(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SUPPLIER',
						keyword: keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*******搜索用户*****************/
			searchUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword: keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
